export const IMAGE_URLS = {
  // Black girl looking to the left in yellow shirt. Used as the main image in the live event card.
  MAIN_LIVE_EVENT_CARD_IMAGE: '/external/assets/MAIN_LIVE_EVENT_CARD_IMAGE.webp',
  // A guy in a grey jacket. Used as a placeholder for the members card image.
  MEMBERS_CARD_IMAGE: '/external/assets/MEMBERS_CARD_IMAGE.png',
  // Picture of Avraham for the Intro video. Used in 'Start Your Journey' section.
  AVRAHAM_INTRO_IMAGE: '/external/assets/AVRAHAM_INTRO_IMAGE.svg',
  // Picture of Avraham making the course behind the scenes. Used in Auth Pages like forget password or reset password.
  AVRAHAM_BEHIND_THE_SCENES_1: '/external/assets/AVRAHAM_BEHIND_THE_SCENES_1.png',
  // StartHub MBA certificate mockup. Used in the auth marketing hero (login/signup/forgot/reset-password).
  AUTH_HERO_CERTIFICATE: '/external/assets/AUTH_HERO_CERTIFICATE.png',

  // Smiling cookie mascot (Figma Miscellaneous 91:10181). Used in the cookie consent banner and its reopen launcher.
  COOKIE_CONSENT_GRAPHIC: '/external/assets/COOKIE_CONSENT_GRAPHIC.webp',

  // Image of Macbook Pro showing video with a teaching on the screen. Used in Apply Card in Founders Landing Page.
  MACBOOK_PRO: '/external/assets/MACBOOK_PRO.png',

  // Image of Iphone showing video with a teaching on the screen. Used in Apply Card in Founders Landing Page.
  IPHONE: '/external/assets/IPHONE.png',

  // Image of a man talking with POV for 1-to-1 Mentor Calls. Used in Founders Mentor Calls section in Founders Landing Page.
  MENTOR_CALLS: '/external/assets/MENTOR_CALLS.png',
  // Image of deals and discounts. Used in Founders Deals and Discounts section in Founders Landing Page.
  // V3: corrected category tags and vendor descriptions (Figma 4657:40157), Sep 2026. New
  // filename because the CDN ignores query strings for caching, so a same-key overwrite never
  // invalidates.
  DEALS_AND_DISCOUNTS: '/external/assets/DEALS_AND_DISCOUNTS_V3.webp',
  // Image of student-facing side of the singular StartHub Scenarios page.
  // Used in Founders Scenarios section in Founders Landing Page.
  SCENARIOS: '/external/assets/SCENARIOS.webp',
  // Image of student-facing side of the singular Live Workshops and Courses page.
  // Used in Founders Live Workshops and Courses section in Founders Landing Page.
  // V2: real course/instructor content (Figma 5624:11119), Aug 2026.
  LIVE_WORKSHOPS_AND_COURSES: '/external/assets/LIVE_WORKSHOPS_AND_COURSES_V2.webp',
  // Image of student-facing side of the singular Email Template page.
  // Used in Founders Email Templates section in Founders Landing Page.
  // V2: refreshed template preview (Figma 5624:11451), Aug 2026.
  EMAIL_TEMPLATES: '/external/assets/EMAIL_TEMPLATES_V2.webp',

  // Password-reset / login-information email hero band (3x PNG for Retina; display width 552).
  PASSWORD_RESET_HERO_BAND: '/external/assets/password-reset-hero-band-3x.png',

  // Password-reset email footer social marks (WebP; ~42px display).
  EMAIL_SOCIAL_INSTAGRAM: '/external/assets/EMAIL_SOCIAL_INSTAGRAM.webp',
  EMAIL_SOCIAL_TIKTOK: '/external/assets/EMAIL_SOCIAL_TIKTOK.webp',
  EMAIL_SOCIAL_LINKEDIN: '/external/assets/EMAIL_SOCIAL_LINKEDIN.webp',
  EMAIL_SOCIAL_YOUTUBE: '/external/assets/EMAIL_SOCIAL_YOUTUBE.webp',

  // Welcome email hero band (3x PNG for Retina; display width 552).
  WELCOME_HERO_BAND: '/external/assets/welcome-hero-band-3x.png',

  // Figma email feature/benefit icon badges (teal accent, PNG, 66px = 22px @ 3x).
  ICON_PERSON: '/external/assets/icon-person.png',
  ICON_ID_CARD: '/external/assets/icon-id-card.png',
  ICON_PHONE: '/external/assets/icon-phone.png',
  ICON_PEOPLE: '/external/assets/icon-people.png',
  ICON_TAG: '/external/assets/icon-tag.png',
  ICON_TOOLS: '/external/assets/icon-tools.png',
  ICON_CLIPBOARD_CHECK: '/external/assets/icon-clipboard-check.png',
  ICON_SHARE: '/external/assets/icon-share.png',
  ICON_PLAY: '/external/assets/icon-play.png',
  ICON_GLOBE: '/external/assets/icon-globe.png',
  // White sparkle for the Welcome CTA button (36px = 12px @ 3x).
  ICON_SPARKLE_WHITE: '/external/assets/icon-sparkle-white.png',

  // USER AVATARS
  LENA_HARTMAN: '/external/assets/LENA_HARTMAN.svg',
  JAMES_CARTER: '/external/assets/JAMES_CARTER.svg',
  SARAH_COLLINS: '/external/assets/SARAH_COLLINS.svg',
  MICHAEL_RODRIGUEZ: '/external/assets/MICHAEL_RODRIGUEZ.svg',
  JESSICA_LEE: '/external/assets/JESSICA_LEE.svg',
  DAVID_KIM: '/external/assets/DAVID_KIM.svg',
  ANNA_PETROVA: '/external/assets/ANNA_PETROVA.svg',
  TOM_GRANT: '/external/assets/TOM_GRANT.svg',
  LAURA_MILLER: '/external/assets/LAURA_MILLER.svg',

  // Temporary shared artwork; dedicated Goodie Bag assets have not been approved.
  GOODIE_BAG_DEALS_DISCOUNTS: '/external/assets/EMAIL_TEMPLATES_V2.webp',
  GOODIE_BAG_EMAIL_TEMPLATES: '/external/assets/EMAIL_TEMPLATES_V2.webp',
  GOODIE_BAG_DOCUMENT_TEMPLATES: '/external/assets/EMAIL_TEMPLATES_V2.webp',
  GOODIE_BAG_SNACKS: '/external/assets/EMAIL_TEMPLATES_V2.webp',
  GOODIE_BAG_PROTECTED_DOWNLOADS: '/external/assets/EMAIL_TEMPLATES_V2.webp',
};
